(function () {
  'use strict';

  // Variáveis
  const fontColor = 'rgb(73, 80, 87)';
  const borderColor = 'rgb(222, 226, 230)';
  const primaryColor = 'rgb(20, 166, 122)';
  const secondaryColor = 'rgb(3, 47, 63)';
  const tertiaryColor = 'rgb(63, 102, 220)';

  // Gráfico de vendas
  const $chartLine = $('#dash-chart-vendas');
  if ($chartLine.length > 0) {
    // Variáveis
    const $chartEl = $chartLine;
    const chartData1 = $chartEl.data('chartdata');
    const ctx = $chartEl[0].getContext('2d');

    // Plano de fundo
    const bgGradient = ctx.createLinearGradient(0, 0, 0, 300);
    bgGradient.addColorStop(0, getRGBA(tertiaryColor, 0.75));
    bgGradient.addColorStop(1, getRGBA(tertiaryColor, 0));
    const bgGradient2 = ctx.createLinearGradient(0, 0, 0, 300);
    bgGradient2.addColorStop(0, getRGBA(secondaryColor, 0.75));
    bgGradient2.addColorStop(1, getRGBA(secondaryColor, 0));
    const bgGradient3 = ctx.createLinearGradient(0, 0, 0, 300);
    bgGradient3.addColorStop(0, getRGBA(primaryColor, 0.85));
    bgGradient3.addColorStop(1, getRGBA(primaryColor, 0.25));

    if (chartData1) {
      const dataSetOpt = {
        borderWidth: 2,
        pointBorderWidth: 2,
        pointRadius: 5,
        pointBorderColor: 'transparent',
        pointHoverRadius: 5,
        pointHoverBorderWidth: 2,
        pointBackgroundColor: 'transparent',
        pointHoverBorderColor: 'white',
      };
      const chartObj = new Chart($chartEl, {
        type: 'line',
        data: {
          labels: chartData1.labels,
          datasets: [
            {
              label: 'Vendas',
              data: chartData1.dataset,
              total: chartData1.dataset_add,
              borderColor: primaryColor,
              backgroundColor: bgGradient3,
              pointHoverBackgroundColor: primaryColor,
              ...dataSetOpt,
            },
          ],
        },
        options: {
          //maintainAspectRatio: false,
          responsive: true,
          legend: {
            display: false,
          },
          hover: {
            mode: 'index',
            intersect: false,
          },
          tooltips: {
            mode: 'index',
            intersect: false,
            backgroundColor: 'white',
            borderColor: borderColor,
            borderWidth: 1,
            titleFontColor: fontColor,
            bodyFontColor: fontColor,
            displayColors: false,
            titleMarginBottom: 4,
            callbacks: {
              label: function (tooltipItem, data) {
                const label = data.datasets[tooltipItem.datasetIndex].label;
                const total = data.datasets[tooltipItem.datasetIndex].total[tooltipItem.index];
                const tooltipLblArr = [label + ': R$ ' + formatMoneyBR(tooltipItem.yLabel) + ' (' + total + ' vendas)'];
                return tooltipLblArr;
              },
            },
          },
          scales: {
            yAxes: [
              {
                gridLines: {
                  color: getRGBA(borderColor, 0.5),
                  display: true,
                  drawBorder: true,
                  zeroLineColor: borderColor,
                  zeroLineWidth: 1,
                },
                ticks: {
                  beginAtZero: true,
                  fontSize: 11,
                  fontColor: fontColor,
                  maxTicksLimit: 6,
                  callback: function (value, index, values) {
                    return formatAmountAbrev(value);
                  },
                },
              },
            ],
            xAxes: [
              {
                display: true,
                gridLines: {
                  display: false,
                },
                ticks: {
                  maxTicksLimit: 10,
                  fontSize: 10,
                  fontColor: fontColor,
                  maxRotation: isMedia('sm') ? 50 : 0,
                },
              },
            ],
          },
        },
      });
    }
  }

  // Retorna a cor com determinada opacidade
  function getRGBA(colorRgb, opacity = 1) {
    return 'rgba(' + colorRgb.replace(/(rgb\(|\))/g, '') + ', ' + opacity + ')';
  }

  // Formata um valor abreviado
  function formatAmountAbrev(amount) {
    let sufix = '';
    if (amount > 999999) {
      sufix = 'm';
      amount = amount / 1000000;
    } else if (amount > 999) {
      sufix = 'k';
      amount = amount / 1000;
    }
    if (amount % 1 > 0) {
      amount = amount.toFixed(1);
      if (amount.split('.')[1] == '0') {
        amount = Math.round(amount);
      }
    }
    return amount + sufix;
  }
})();
